import { ReactComponent as ScanPassport1 } from "assets/images/scan-passport-1.svg";
import { ReactComponent as ScanPassport2 } from "assets/images/scan-passport-2.svg";
import { ReactComponent as ScanPassport3 } from "assets/images/scan-passport-3.svg";

const STEPS = [
  {
    title: "smart_gate.guide_step_1_title",
    description: "smart_gate.guide_step_1_description",
    illustration: <ScanPassport1 />,
    illustrationStyle: {
      width: "100vw",
      height: "500px",
      objectFit: "contain",
      top: "-110px",
      transform: "translateX(-30px)",
    },
    circlePosition: {
      x: -515,
      y: 361,
    },
  },
  {
    title: "smart_gate.guide_step_2_title",
    description: "smart_gate.guide_step_2_description",
    illustration: <ScanPassport2 />,
    illustrationStyle: {
      width: "100vw",
      height: "320px",
      objectFit: "contain",
      top: "-20px",
    },
    circlePosition: {
      x: -342,
      y: 70,
    },
  },
  {
    title: "smart_gate.guide_step_3_title",
    description: "smart_gate.guide_step_3_description",
    illustration: <ScanPassport3 />,
    illustrationStyle: {
      width: "100vw",
      height: "280px",
      objectFit: "contain",
      top: "-15px",
    },
    circlePosition: {
      x: -52,
      y: 366,
    },
  },
];

export default STEPS;
